export default {
  dark: {
    id:'dark',
    background: '#2C2C2C',
    selection: 'white',
    font: 'rgba(112,112,112,0.15)'
  },
  light: {
    id:'light',
    background: 'lightgrey',
    selection: 'red',
    font: 'rgba(112,112,112,0.15)'
  }
}